import type { Receipt } from './useBarCodeReader'

export const isReceiptAlreadySelected = (
  barCode: string,
  selectedReceipt: Receipt | null
): boolean => {
  if (!selectedReceipt) return false

  return selectedReceipt.shippingReceiptCarrierTags.some((tag) =>
    [tag.barCode1, tag.barCode2].includes(barCode)
  )
}

export const findReceiptByBarCode = (barCode: string, receipts: Receipt[]): Receipt | undefined =>
  receipts.find((receipt) =>
    receipt.shippingReceiptCarrierTags.some((tag) => [tag.barCode1, tag.barCode2].includes(barCode))
  )
